@use '../../global/icons';

:host {
  display: inline-flex;

  button, a {
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: auto;
    max-width: 100%;
    padding: 0 var(--lgr-spacing-xxxs);
    border-radius: var(--lgr-border-radius-xx-lg);
    font-family: var(--lgr-font-family-regular);
    font-size: var(--lgr-font-size-md);
    line-height: normal;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    user-select: none;

    lgr-icon {
      margin-right: var(--lgr-spacing-nano);
      font-size: var(--lgr-font-size-lg);
    }

    span.icon-custom {
      margin-right: var(--lgr-spacing-nano);
      display: flex;
      align-items: center;
      justify-content: center;
      width: var(--lgr-font-size-lg);
      height: var(--lgr-font-size-lg);
    }

    span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .spinner {
      @keyframes spinning {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }

      display: inline-block;
      position: absolute;
      aspect-ratio: 1;
      width: var(--lgr-font-size-xl);
      height: var(--lgr-font-size-xl);
      border: 2px solid;
      border-radius: 50%;
      border-bottom-color: transparent;
      box-sizing: border-box;
      animation: spinning 1s linear infinite;
    }

    &.primary {
      border: none;
      background-color: var(--lgr-color-brand-primary);
      color: var(--lgr-color-neutral-high-pure);

      &:hover {
        background-color: var(--lgr-color-brand-primary-dark);
      }

      &:active {
        background-color: var(--lgr-color-brand-primary-light);
      }

      &:disabled,
      &[disabled] {
        background-color: var(--lgr-color-neutral-low-light);
      }

      span.icon-custom {
        svg {
          path {
            fill: var(--lgr-color-neutral-high-pure);
          }
        }
      }
    }

    &.white {
      border: none;
      background-color: var(--lgr-color-neutral-high-pure) ;
      color: var(--lgr-color-brand-primary);

      &:hover {
        color: var(--lgr-color-neutral-high-pure);
        background-color: var(--lgr-color-brand-primary-dark);
      }

      &:active {
        color: var(--lgr-color-neutral-high-pure);
        background-color: var(--lgr-color-brand-primary-light);
      }

      &:disabled,
      &[disabled] {
        color: var(--lgr-color-neutral-high-pure);
        background-color: var(--lgr-color-neutral-low-light);
      }
      span.icon-custom {
        svg {
          path {
            fill: var(--lgr-color-brand-primary);
          }
        }
      }
    }

    &.secondary {
      border-width: var(--lgr-border-size-default);
      border-style: solid;
      border-color: var(--lgr-color-brand-primary);
      background-color: transparent;
      color: var(--lgr-color-brand-primary);

      &:hover {
        border-color: var(--lgr-color-brand-primary-dark);
        color: var(--lgr-color-brand-primary-dark);
      }

      &:active {
        border-color: var(--lgr-color-brand-primary-light);
        color: var(--lgr-color-brand-primary-light);
      }

      &:disabled {
        border-color: var(--lgr-color-neutral-low-light);
        color: var(--lgr-color-neutral-low-light);
      }

      &.inverse {
        border-width: var(--lgr-border-size-default);
        border-style: solid;
        border-color: var(--lgr-color-neutral-high-pure);
        background-color: transparent;
        color: var(--lgr-color-neutral-high-pure);

        &:hover {
          opacity: var(--lgr-alpha-semi-opaque);
        }

        &:active {
          opacity: 1;
        }

        &:disabled {
          opacity: var(--lgr-alpha-intense);
        }
      }
      span.icon-custom {
        svg {
          path {
            fill: var(--lgr-color-brand-primary);
          }
        }
      }
    }

    &.text {
      border: none;
      background-color: transparent;
      color: var(--lgr-color-brand-primary);

      &:hover {
        color: var(--lgr-color-brand-primary-dark);
      }

      &:active {
        color: var(--lgr-color-brand-primary-light);
      }

      &:disabled {
        color: var(--lgr-color-neutral-low-light);
      }

      &.inverse {
        color: var(--lgr-color-neutral-high-pure);

        &:hover {
          opacity: var(--lgr-alpha-semi-opaque);
        }

        &:active {
          opacity: 1;
        }

        &:disabled {
          opacity: var(--lgr-alpha-intense);
        }
      }
      span.icon-custom {
        svg {
          path {
            fill: var(--lgr-color-brand-primary);
          }
        }
      }
    }

    &.large {
      height: var(--lgr-spacing-md);

      .spinner {
        width: var(--lgr-font-size-xl);
        height: var(--lgr-font-size-xl);
      }
    }

    &.small {
      height: var(--lgr-spacing-xs);
      font-size: var(--lgr-font-size-sm);

      .spinner {
        width: var(--lgr-font-size-md);
        height: var(--lgr-font-size-md);
      }
    }

    &.loading {
      .label,
      .icon {
        visibility: hidden;
      }
    }

    &.full-width {
      width: 100%;
    }

    &:disabled {
      cursor: default;
    }

    .label {
      display: flex;
      align-items: center;
      gap: var(--lgr-spacing-nano);
    }
  }
}
